import React from 'react';
import ProjectCard from '../components/ProjectCard';
import projects from '../content/projects';
import './Projects.css';

const ProjectIndex = () => {
  return (
    <div className="projects-page">
      <main className="site-container--wide projects-main">
        <header className="projects-header">
          <h1 className="projects-heading">Projects</h1>
        </header>

        <div className="projects-grid">
          {projects.length > 0 ? (projects.map((project) => (
            <ProjectCard key={project.slug} {...project} />
          ))
          ) : (
            <p className="projects-placeholder">No projects to show yet. Check back soon!</p>
          )}
        </div>
      </main>
    </div>
  );
};

export default ProjectIndex;
